import ACTIONS from "../constants/actions";

const {
  GET_JOB_TYPE,
  GET_JOB_TYPE_FAIL,
  GET_JOB_TYPE_SUCCESS,
  ADD_JOB_TYPE_REQUEST,
  ADD_JOB_TYPE_REQUEST_SUCCESS,
  ADD_JOB_TYPE_REQUEST_FAIL,
  GET_JOB_TYPE_BY_ID_REQUEST,
  GET_JOB_TYPE_BY_ID_REQUEST_SUCCESS,
  GET_JOB_TYPE_BY_ID_REQUEST_FAIL,
} = ACTIONS;

const initialState = {
  isLoadingJobTypes: false,
  jobTypes: [],
  isLoadingJobTypeById: false,
  jobType: {},
};

const jobTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_JOB_TYPE:
      return {
        ...state,
        isLoadingJobTypes: true,
      };
    case GET_JOB_TYPE_SUCCESS:
      return {
        ...state,
        isLoadingJobTypes: false,
        jobTypes: action.payload,
      };
    case GET_JOB_TYPE_FAIL:
      return {
        ...state,
        isLoadingJobTypes: false,
      };
    case ADD_JOB_TYPE_REQUEST:
      return {
        ...state,
      };
    case ADD_JOB_TYPE_REQUEST_SUCCESS:
      return {
        ...state,
      };
    case ADD_JOB_TYPE_REQUEST_FAIL:
      return {
        ...state,
      };
    case GET_JOB_TYPE_BY_ID_REQUEST:
      return {
        ...state,
        isLoadingJobTypeById: true,
      };
    case GET_JOB_TYPE_BY_ID_REQUEST_SUCCESS:
      return {
        ...state,
        isLoadingJobTypeById: false,
        jobType: action.payload,
      };
    case GET_JOB_TYPE_BY_ID_REQUEST_FAIL:
      return {
        ...state,
        isLoadingJobTypeById: false,
      };
    default:
      return state;
  }
};
export default jobTypeReducer;
